import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="marquee-mask relative overflow-hidden border-y border-[#1A1A20] bg-[#0A0A0C] py-5">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-sm font-bold uppercase tracking-[0.25em] text-zinc-400">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#E50914]" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};
